const $ = require("jquery");
const Modernizr = require('../../vendors/modernizr.min');
const ko = require("knockout");
const ChatViewModel = require("./chat.vm");
const _throttle = require('lodash/throttle');
require("../../scripts/custom-ko-bindings");

$(function () {
    const desktopMq = '(min-width: 992px)';
    const $window = $(window),
        $footer = $(".ws-footer"),
        $chatButton = $(".ws-chat__btn"),
        $chatButtonTextWrapper = $(".ws-chat__btn-text-wrapper"),
        invertedFocusClass = "ws-chat__btn--inverted-focus",
        chatRequiresFocusStyling = ($footer.length && !$footer.hasClass("ws-footer--simplified"));

    $(".ws-chat").each(function () {
        const $this = $(this),
            viewModel = new ChatViewModel(
                $this,
                $this.data("participant-id"),
                $this.data("chat-target")
            );

        ko.applyBindings(viewModel, this);
    });

    const setFocusColorStyling = function () {
        if (WS.isFixedElementOverFooter($chatButton, $footer)) {
            $chatButton.addClass(invertedFocusClass);
        }
        else {
            $chatButton.removeClass(invertedFocusClass);
        }
    };

    const chatAnimationHandler = function () {
        const currentScrollPos = $window.scrollTop();
        const isDesktop = Modernizr.mq(desktopMq);

        if (chatRequiresFocusStyling) {
            setFocusColorStyling();
        }

        if (currentScrollPos >= 20 || !isDesktop) {
            $chatButton.addClass("ws-chat__btn--scrolled");
            $chatButtonTextWrapper.hide();
        } else if (isDesktop) {
            $chatButton.removeClass("ws-chat__btn--scrolled");
            $chatButtonTextWrapper.show(200).css("display", "inline-flex");
        }
    };
    if ($('.ws-chat__btn').length) {
        $window.on("scroll load resize", _throttle(chatAnimationHandler, 50));
    }
});